module.exports = __webpack_public_path__ + "media/images/ogimage-6553662828d21fd89d9a087501c83798.jpg";